import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=1bc12eb8&scoped=true&"
import script from "./agent.vue?vue&type=script&lang=js&"
export * from "./agent.vue?vue&type=script&lang=js&"
import style0 from "./agent.vue?vue&type=style&index=0&id=1bc12eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc12eb8",
  null
  
)

export default component.exports